var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-container"},[_c('span',{staticClass:"app-header"},[_c('UserProfileIcon',{staticClass:"app-header-icon"}),_c('span',{staticClass:"app-header-text"},[_vm._v(_vm._s(_vm.title))])],1),_c('div',{staticClass:"container"},[(_vm.$store.getters.isAuthenticated)?_c('user-profile-card'):_c('guest-profile-card')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }